import { useParams, Link, useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { Button, Grid, Box, TablePagination, Autocomplete, Tooltip, TextField, Typography, Modal } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useState } from 'react';
import { useEffect } from 'react';
import { useApi } from 'Service/axios';
import { HeaderBox } from './style';
import { toast } from 'react-toastify';
import EntradaTabela from 'components/Entrada/Tabela';
import { DataGrid } from '@mui/x-data-grid';
import ActionButtonsTabela from 'components/Entrada/ActionButtonTabela';
import { pdf, PDFViewer } from '@react-pdf/renderer';
import PdfEntradaNota from 'components/PDF/Estoque/PdfEntradaNota';

import { Worker, Viewer } from '@react-pdf-viewer/core';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { printPlugin } from '@react-pdf-viewer/print';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

const stylePdf = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1100,
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '80vh'
};

const EntradaEstoque = () => {
    // ============================= pdf =============================
    const getFilePluginInstance = getFilePlugin();
    const { DownloadButton } = getFilePluginInstance;
    const printPluginInstance = printPlugin();
    const { PrintButton } = printPluginInstance;
    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    // ============================= INSTÂNCIAS =============================
    const api = useApi();
    const navigate = useNavigate();
    // ============================= STATES =============================
    const [allEntrada, setAllEntrada] = useState([]);
    const [selectedEntrada, setSelectedEntrada] = useState(null);
    const [entrada, setEntrada] = useState(null);
    const [dataPdf, setDataPdf] = useState(null);
    const [openModalPdf, setOpenModalPdf] = useState(false);
    const [openModalPdfViewer, setOpenModalPdfViewer] = useState(false);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);

    const getEntradas = async () => {
        try {
            const { data } = await api.getAllEntradasEstoques();
            const mappedRows = await Promise.all(
                data?.map(async (item) => {
                    let pdfUrl = null;

                    if (item?.notaFiscal?.arquivo?.data) {
                        pdfUrl = await getPdfBlob(item?.notaFiscal?.arquivo?.data);
                    }

                    return {
                        ...item,
                        obra: item.obra ? item.obra.descricao : '-',
                        pdf: pdfUrl
                    };
                })
            );

            console.log('🚀 ~ row ~ row:', mappedRows);
            setAllEntrada(mappedRows);
        } catch (error) {
            toast.error(error.response.data.mensagem);
        }
    };
    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.3 },
        { field: 'numero_documento', headerName: 'DOCUMENTO', flex: 0.7 },
        { field: 'fornecedor', headerName: 'FORNECEDOR', flex: 2, valueGetter: (params) => params.row.fornecedor.nome_fantasia },
        { field: 'obra', headerName: 'OBRA', flex: 1 },
        {
            field: 'data_entrada',
            headerName: 'DATA DE ENTRADA',
            flex: 1,
            valueGetter: (params) => {
                return new Date(params.row.data_entrada).toLocaleDateString('pt-BR');
            }
        },
        {
            field: 'acao',
            headerName: 'AÇÕES',
            flex: 0.8,
            sortable: false,
            renderCell: (params) => {
                return (
                    <ActionButtonsTabela
                        row={params.row}
                        setCurrentRow={setCurrentRow}
                        setOpenModalPdfViewer={setOpenModalPdfViewer}
                        setOpenModalPdf={setOpenModalPdf}
                        getEntradaById={getDataEntradaById}
                        getEntradas={getEntradas}
                    />
                );
            }
        }
    ];
    // ============================= FUNÇÕES =============================

    const handleSelectionModelChange = (newSelection) => {
        setSelectedItems(newSelection);
    };

    const handleClickOpenEdit = (e, item) => {
        e.preventDefault();
        setEntrada(item);
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNavigate = () => {
        navigate('/main/estoque/entrada/cadastro');
    };

    async function getPdfBlob(data) {
        const byteArray = new Uint8Array(data);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        return URL.createObjectURL(blob);
    }

    async function getDataEntradaById(id) {
        try {
            const { data } = await api.getEntradaEstoqueById(id);
            setDataPdf(data);
            setOpenModalPdf(true);
        } catch (error) {
            toast.error(`Erro ao buscar entrada: ${error.message}`);
        }
    }

    useEffect(() => {
        getEntradas();
    }, []);

    return (
        <MainCard>
            {/* <Modal
                open={openModalPdf}
                onClose={() => {
                    setOpenModalPdf(false);
                }}
            >
                <Box sx={stylePdf}>
                    <PDFViewer width={'100%'} height={'100%'}>
                        <PdfEntradaNota data={dataPdf} />
                    </PDFViewer>
                </Box>
            </Modal> */}
            <Modal
                open={openModalPdfViewer}
                onClose={() => {
                    setCurrentRow(null);
                    setOpenModalPdfViewer(false);
                }}
            >
                <Box sx={stylePdf}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '1rem',
                            padding: '4px',
                            alignItems: 'center',
                            backgroundColor: '#eeeeee',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        <DownloadButton />
                        <PrintButton />
                        <ZoomOutButton />
                        <ZoomPopover />
                        <ZoomInButton />
                    </Box>
                    {currentRow?.pdf ? (
                        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                            <Viewer fileUrl={currentRow.pdf} plugins={[getFilePluginInstance, printPluginInstance, zoomPluginInstance]} />
                        </Worker>
                    ) : (
                        <Box sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="body1">Erro ao exibir PDF</Typography>
                        </Box>
                    )}
                </Box>
            </Modal>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '2em'
                }}
            >
                <Typography sx={{ fontSize: '1.125rem', fontWeight: '500' }}>Entrada</Typography>
                <Button variant="contained" size="medium" onClick={handleNavigate} sx={{ height: '40px' }}>
                    Adicionar
                </Button>
            </Box>
            <Grid container spacing={gridSpacing}>
                <Box sx={{ width: '100%' }}>
                    <DataGrid
                        rows={allEntrada}
                        sx={{ height: 'calc(100vh - 240px)' }}
                        columns={columns}
                        onSelectionModelChange={() => handleSelectionModelChange(params.id)}
                    />
                </Box>
            </Grid>
        </MainCard>
    );
};

export default EntradaEstoque;
